import { getCCEmailsConstants, updateCCEmailsConstants } from '../constants/ccEmailsConstants';

const { createFetchStandartFlowActionCreators } = require('../../utils/helpers/actionCreatorHelpers');

// eslint-disable-next-line max-len
export const getCCEmailsActionCreators = createFetchStandartFlowActionCreators(getCCEmailsConstants);
// eslint-disable-next-line max-len
export const updateCCEmailsActionCreators = createFetchStandartFlowActionCreators(updateCCEmailsConstants);
